import React, { useContext, useRef, useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"

import { AppContext } from "../../../context/AppContext"
import ChargerCard from "../../HomeConfigure/ChargerCard/ChargerCard"

import styles from "./ChargersMenuSlider.module.scss"

const ChargersMenuSlider = ({ from }) => {
  const { store } = useContext(AppContext)
  const { t } = useTranslation()
  const swiperRef = useRef(null)
  const [canGrab, setCanGrab] = useState(false)

  const chargers = store.chargers.filter(
    charger =>
      !store.selectedSector ||
      charger.sectors.includes(store.selectedSector)
  )

  useEffect(() => {
    const swiperInstance = swiperRef.current?.swiper

    const updateCursor = () => {
      if (!swiperInstance) return
      const { isBeginning, isEnd } = swiperInstance
      setCanGrab(!(isBeginning && isEnd))
    }

    if (swiperInstance) {
      swiperInstance.on("slideChange", updateCursor)
      swiperInstance.on("reachEnd", updateCursor)
      swiperInstance.on("reachBeginning", updateCursor)
      updateCursor()
    }

    window.addEventListener("resize", updateCursor)

    return () => {
      swiperInstance?.off("slideChange", updateCursor)
      swiperInstance?.off("reachEnd", updateCursor)
      swiperInstance?.off("reachBeginning", updateCursor)
    }
  }, [])

  const containerClass = [
    styles.chargersMenuContainer,
    canGrab ? styles.canGrab : styles.cannotGrab,
  ].join(" ")

  return (
    <div className={styles.wrapper}>
      {from === "home" ? (
        <div className={[styles.title, styles.titleHome].join(" ")}>
          {t("chargers menu home")}
        </div>
      ) : (
        <div className={styles.title}>
          {t("chargers menu homeConfigure")}
        </div>
      )}
      <Swiper
        ref={swiperRef}
        onSwiper={(swiperInstance) => {
          const { isBeginning, isEnd } = swiperInstance
          setCanGrab(!(isBeginning && isEnd))
          swiperInstance.on("slideChange", () => {
            const { isBeginning, isEnd } = swiperInstance
            setCanGrab(!(isBeginning && isEnd))
          })
          swiperInstance.on("reachEnd", () => setCanGrab(false))
          swiperInstance.on("reachBeginning", () => setCanGrab(false))
        }}
        slidesPerView={1.2}
        spaceBetween={16}
        slidesOffsetBefore={20}
        slidesOffsetAfter={20}
        breakpoints={{
          1024: {
            slidesPerView: 2.2,
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
          },
          1440: {
            slidesPerView: 3.5,
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
          },
          1921: {
            slidesPerView: 4,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        }}
        className={containerClass}
      >
        {chargers.map((charger) => (
          <SwiperSlide key={charger.code} style={{ height: "auto" }}>
            <ChargerCard charger={charger} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default ChargersMenuSlider
